/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlayerCareer } from '../models/PlayerCareer';
import type { PlayerCareerCreate } from '../models/PlayerCareerCreate';
import type { PlayerCareerPatch } from '../models/PlayerCareerPatch';
import type { PlayerCareerVerifiedPatch } from '../models/PlayerCareerVerifiedPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CareerService {
    /**
     * Get Player Career
     * @param playerId
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static getPlayerCareerPlayerCareerPlayerIdGet(
        playerId: number,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_career/{player_id}',
            path: {
                'player_id': playerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Player Career Entry
     * @param requestBody
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static createPlayerCareerEntryPlayerCareerPost(
        requestBody: PlayerCareerCreate,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/player_career/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Verified Career Entry Hidden
     * @param playerTeamPositionId
     * @param hidden
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static setVerifiedCareerEntryHiddenPlayerCareerHiddenPlayerTeamPositionIdPut(
        playerTeamPositionId: number,
        hidden: boolean,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/player_career/hidden/{player_team_position_id}',
            path: {
                'player_team_position_id': playerTeamPositionId,
            },
            query: {
                'hidden': hidden,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Verified Career Entry
     * @param playerCareerId
     * @param requestBody
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static patchVerifiedCareerEntryPlayerCareerVerifiedPlayerCareerIdPatch(
        playerCareerId: number,
        requestBody: PlayerCareerVerifiedPatch,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/player_career/verified/{player_career_id}',
            path: {
                'player_career_id': playerCareerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Player Career Entry
     * @param careerId
     * @param requestBody
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static patchPlayerCareerEntryPlayerCareerCareerIdPatch(
        careerId: number,
        requestBody: PlayerCareerPatch,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/player_career/{career_id}',
            path: {
                'career_id': careerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Player Career Entry
     * @param playerCareerId
     * @returns PlayerCareer Successful Response
     * @throws ApiError
     */
    public static deletePlayerCareerEntryPlayerCareerPlayerCareerIdDelete(
        playerCareerId: number,
    ): CancelablePromise<PlayerCareer> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/player_career/{player_career_id}',
            path: {
                'player_career_id': playerCareerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
